import { NgClass } from '@angular/common';
import { Component, inject, OnInit, Input, ChangeDetectionStrategy, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';

import { ApplicationPreloadService } from 'projects/admin/src/app/service/application-preload.service';
import { HeaderService } from 'projects/client/src/app/service/header.service';
import { SvgAssetComponent } from 'projects/design-system/components/svg-icon/svg-icon.component';
import { INavLink } from 'shared/components/navigation-bar/nav-link.interface';
import { RoleEnum } from 'shared/openapi/models';

@Component({
	selector: 'app-admin-profile',
	templateUrl: './admin-profile.component.html',
	imports: [SvgAssetComponent, NgClass, TranslateModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class AdminProfileComponent implements OnInit {
	@Input({ required: false }) navLinks: INavLink[] | null = [];
	public adminName = signal<string | undefined>(undefined);
	public adminRole = signal<string | undefined>(undefined);
	protected headerService = inject(HeaderService);
	protected readonly keycloakService = inject(Keycloak);
	private translate = inject(TranslateService);
	protected readonly applicationPreloadService = inject(ApplicationPreloadService);

	ngOnInit() {
		this.getAdminName();
		this.getAdminRoleTranslate();
	}

	private async getAdminName() {
		this.adminName.set((await this.applicationPreloadService.getAuthState()).name);
	}

	private async getAdminRoleTranslate() {
		const roles = (await this.applicationPreloadService.getAuthState()).roles as string[];
		for (const role of Object.values(RoleEnum)) {
			if (roles.includes(role)) {
				this.adminRole.set(this.translate.instant('common.role.' + role));
				break;
			}
		}
	}
}
